import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";

export const ResurrectionCountdown = () => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const diff = Math.max(0, new Date("2026-08-18T00:00:00").getTime() - now);
  const cells = [
    ["DAYS", Math.floor(diff / 86400000)],
    ["HRS", Math.floor(diff / 3600000) % 24],
    ["MIN", Math.floor(diff / 60000) % 60],
    ["SEC", Math.floor(diff / 1000) % 60],
  ];
  return (
    <Link to="/pre-order" className="inline-flex flex-col items-center group" data-testid="home-resurrection-countdown">
      <span className="overline text-primary inline-flex items-center gap-1.5 mb-3"><Lightning weight="fill" size={13} /> The Resurrection · Aug 18 · Born again</span>
      <div className="flex items-center gap-4 sm:gap-6">
        {cells.map(([l, v]) => (
          <div key={l} className="text-center">
            <div className="font-display font-black text-3xl sm:text-5xl neon-text tabular-nums leading-none group-hover:scale-105 transition-transform">{String(v).padStart(2, "0")}</div>
            <div className="overline text-muted-foreground text-[10px] mt-1">{l}</div>
          </div>
        ))}
      </div>
    </Link>
  );
};

export default ResurrectionCountdown;
